export const projectsData = [
    {
        id: 1,
        title: 'Modern Villa Design',
        category: 'Residential',
        location: 'Raipur, CG',
        image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80',
        description: 'Luxurious 4BHK villa with contemporary design and sustainable features.',
        longDescription: `This stunning 4BHK villa in Raipur exemplifies modern luxury living. Designed with a focus on open spaces and natural light, the property features floor-to-ceiling windows, a double-height living area, and a private landscaped garden. Sustainable features include solar panels, rainwater harvesting, and energy-efficient lighting throughout. The interior design blends warmth efficiently with cool contemporary aesthetics.`,
        status: 'Completed',
        date: 'December 2023',
        client: 'Private Client',
        area: '4,500 sq ft',
        amenities: ['Private Garden', 'Home Theater', 'Smart Home System', 'Solar Integration'],
        gallery: [
            'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80',
            'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80',
            'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=600&q=80'
        ]
    },
    {
        id: 2,
        title: 'Corporate Office Interior',
        category: 'Commercial',
        location: 'Raipur, CG',
        image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80',
        description: 'Modern office space designed for productivity and collaboration.',
        longDescription: `A state-of-the-art office space designed to foster creativity and collaboration. The layout features open-plan work stations, ergonomic furniture, and dedicated breakout zones. Acoustic treatments and advanced lighting solutions ensure a comfortable work environment. The design reflects the corporate identity through branding integration and a professional color palette.`,
        status: 'Completed',
        date: 'August 2023',
        client: 'Tech Solutions Ltd.',
        area: '12,000 sq ft',
        amenities: ['Video Conference Rooms', 'Cafeteria', 'Lounge Area', 'Server Room'],
        gallery: [
            'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=80',
            'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=600&q=80',
            'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=600&q=80'
        ]
    },
    {
        id: 3,
        title: 'Apartment Complex',
        category: 'Residential',
        location: 'Raipur, CG',
        image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&q=80',
        description: '50-unit residential complex with modern amenities and green spaces.',
        longDescription: `A premium residential complex comprising 50 distinct units. The project emphasizes community living with extensive shared amenities including a clubhouse, swimming pool, and landscaped parks. Each apartment is designed for maximum space efficiency and ventilation.`,
        status: 'In Progress',
        date: 'Expected 2024',
        client: 'Skyline Developers',
        area: '2 Acres',
        amenities: ['Clubhouse', 'Swimming Pool', 'Jogging Track', '24/7 Security'],
        gallery: [
            'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&q=80',
            'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&q=80',
            'https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=600&q=80'
        ]
    },
    {
        id: 4,
        title: 'Restaurant Interior',
        category: 'Commercial',
        location: 'Raipur, CG',
        image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80',
        description: 'Elegant dining space with contemporary aesthetics and ambiance.',
        longDescription: `An upscale dining venue designed to offer an immersive culinary experience. The interior uses rich textures, ambient lighting, and bespoke furniture to create a sophisticated yet welcoming atmosphere. The kitchen layout is optimized for efficiency while the dining area maximizes privacy and comfort.`,
        status: 'Completed',
        date: 'February 2023',
        client: 'Savor Group',
        area: '2,500 sq ft',
        amenities: ['Open Kitchen', 'Bar Area', 'Private Dining', 'Acoustic Ceilings'],
        gallery: [
            'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&q=80',
            'https://images.unsplash.com/photo-1552566626-52f8b828add9?w=600&q=80',
            'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=600&q=80'
        ]
    },
    {
        id: 5,
        title: 'Luxury Farmhouse',
        category: 'Residential',
        location: 'Raipur, CG',
        image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1200&q=80',
        description: 'Spacious farmhouse with traditional elements and modern comforts.',
        longDescription: `A sprawling farmhouse retreat that harmonizes traditional architecture with modern luxury. Featuring a central courtyard, verandas, and a pool, the home is a sanctuary away from the city. The use of local materials like stone and wood gives it a timeless character.`,
        status: 'Completed',
        date: 'May 2022',
        client: 'Private Client',
        area: '10,000 sq ft',
        amenities: ['Swimming Pool', 'Organic Garden', 'Outdoor Kitchen', 'Guest Wing'],
        gallery: [
            'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600&q=80',
            'https://images.unsplash.com/photo-1613545325278-f24b0cae1224?w=600&q=80',
            'https://images.unsplash.com/photo-1613977257363-707ba9348227?w=600&q=80'
        ]
    },
    {
        id: 6,
        title: 'Retail Showroom',
        category: 'Commercial',
        location: 'Raipur, CG',
        image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&q=80',
        description: 'Contemporary retail space designed to enhance customer experience.',
        longDescription: `A high-end retail showroom designed to highlight products and facilitate customer flow. The space utilizes minimalist display units, strategic lighting, and a neutral color palette to let the merchandise stand out.`,
        status: 'In Progress',
        date: 'Expected Late 2024',
        client: 'Fashion Retailers',
        area: '3,000 sq ft',
        amenities: ['Fitting Rooms', 'Display Zones', 'Storage Unit', 'Waiting Lounge'],
        gallery: [
            'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&q=80',
            'https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=600&q=80',
            'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=600&q=80'
        ]
    },
];
